import {useTranslation} from 'react-i18next'
import {InfoMessage} from '@components/lib'

import useIsCryptoApiWorking from 'hooks/helpers/useIsCryptoApiWorking'

const LabelCryptoApi = ({...rest}) => {
  const {t} = useTranslation()
  const {isCryptoApiWorking, isLoadingCryptoApiWorking} = useIsCryptoApiWorking()
  if (!isCryptoApiWorking && !isLoadingCryptoApiWorking)
    return (
      <InfoMessage
        nature='error'
        text={t('wallet.cryptoApiNotAvailable')}
        style={{marginTop: 15}}
        {...rest}
      />
    )
  return null
}

export default LabelCryptoApi
